import React from 'react'
import { pricelist } from './constants/pricelist'
import { shipping } from './constants/shipping'
import { Link } from 'react-router-dom'

export default function Pricelist() {
    return (
        <>
            <section id="pricelist">
                <h2>Ceník</h2>
                <table className="w-full select-none">
                    <thead>
                        <tr className="flex justify-between">
                            <th className="font-normal">Velikost</th>
                            <th className="font-normal">Cena</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pricelist.map((item, index) => (
                            <tr
                                key={index}
                                className="flex justify-between italic hover:cursor-not-allowed hover:text-red-600 mt-1"
                            >
                                <td>{item.size} cm</td>
                                <td>~{item.price} CZK</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <p>
                    * Uvedené ceny jsou pouze odhad. Ceny se u každého koberečku
                    liší, podle složitosti, počtu písmen a velikosti. Každou
                    cenu určuji individuálně, proto se neboj mi napsat na můj{' '}
                    <a
                        href="https://ig.me/m/drippy_rugs"
                        target="_blank"
                        rel="noreferrer"
                    >
                        instagram
                    </a>
                    , kde se na všem domluvíme.
                </p>
                <p>
                    ** U každého koberečku je možnost zvolit si detailing,
                    kterým dosáhneme čistšího vzhledu koberečku. Rozdíl{' '}
                    <Link to="/compare">zde</Link>.
                </p>
            </section>

            <section id="shipping" className="mt-10">
                <h2>Poštovné</h2>
                <h3 className="mt-2">Česká Republika</h3>
                <table className="w-full select-none">
                    <tbody>
                        {shipping.cz.map((item, index) => (
                            <tr
                                key={index}
                                className="flex justify-between italic hover:cursor-not-allowed hover:text-red-600 mt-1"
                            >
                                <td>{item.size} cm</td>
                                <td>~{item.price} CZK</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <h3 className="mt-8">Slovensko</h3>
                <table className="w-full select-none">
                    <tbody>
                        {shipping.sk.map((item, index) => (
                            <tr
                                key={index}
                                className="flex justify-between italic hover:cursor-not-allowed hover:text-red-600 mt-1"
                            >
                                <td>{item.size} cm</td>
                                <td>~{item.price}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <h3 className="mt-8">Ostatní</h3>
                <p>
                    Zásilky pro ostatní země zasílám individuálně po domluvě.
                    Ceny se od každé země můžou lišit.
                </p>
            </section>
        </>
    )
}
